import React from 'react';
// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { Chip, MenuItem } from '@mui/material';
import {
    TextSnippet as TextSnippetIcon,
    Comment as CommentIcon
} from '@mui/icons-material';
import i18n from '../../../i18n';
import DocumentsDialog from '../../dialogs/DocumentsDialog';
import CommentsDialog from '../../dialogs/CommentsDialog';
import Iconify from '../../../components/iconify';
import { reasonCodesConfig } from '../../../config/reasonCodes.config';
import { fraudStatuses } from '../statuses';
import ConfirmDialog from '../../dialogs/ConfirmDialog';
export default class FraudsPage extends GridPageAbstract {
    fraudsDocuments = [];
    fraudsComments = [];

    constructor(props) {
        super(props);

        this.Name = 'publicFrauds';
        this.Server = this.props.context.getState().server.publicFrauds;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['reason', 'description', 'payment.uuid'];
        this.showTotalRow = true;
        this.exportButton = true;

        this.hasCustomLogicOnMount = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'reason',
                    label: 'reason',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    displayAdd: true,
                    disableEditor: true
                },
                {
                    id: 'reasonCode',
                    label: 'reasonCode',
                    alignRight: false,
                    cell: 'Entity',
                    items: reasonCodesConfig,
                    displayGrid: true,
                    displayAdd: true,
                    disableEditor: true
                },
                {
                    id: 'description',
                    label: 'description',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    displayAdd: true,
                    disableEditor: true
                },
                {
                    id: 'externalCaseId',
                    label: 'externalCaseId',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'rrn',
                    label: 'rrn',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    displayAdd: true,
                    disableEditor: true
                },
                {
                    id: 'state',
                    label: 'status',
                    alignRight: false,
                    cell: 'State',
                    items: Object.keys(fraudStatuses),
                    displayAdd: true,
                    displayGrid: true
                },
                {
                    id: 'commissions',
                    label: 'commissions',
                    alignRight: false,
                    cell: 'CommissionsTotal',
                    from: 'publicCommissions',
                    total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true
                },
                {
                    id: 'paymentUuid',
                    label: 'paymentUuid',
                    alignRight: false,
                    cell: 'ServerSearch',
                    searchFields: ['uuid'],
                    outputField: 'uuid',
                    searchController: 'paymentInstances',
                    object: 'payment',
                    show: 'uuid',
                    displayGrid: true,
                    displayAdd: true,
                    disableEditor: true
                },
                {
                    id: 'fraudsDocuments',
                    label: 'fraudsDocuments',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true,
                    customData: true,
                    disableSort: true
                },
                {
                    id: 'fraudsComments',
                    label: 'fraudsComments',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true,
                    customData: true,
                    disableSort: true
                },
                {
                    id: 'modifiedReason',
                    label: 'modifiedReason',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'modifiedBy',
                    label: 'modifiedBy',
                    alignRight: false,
                    cell: 'Select',
                    object: 'modifiedBy',
                    show: 'firstName+lastName',
                    displayGrid: true,
                    disableEditor: true,
                    customSort: 'modifiedBy.firstName',
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                },
            ];

        this.state = {
            ...this.state,
            head: this.Head,

            currentFraudDocuments: [],
            currentFraudComments: [],
            fraudsDocumentsOpen: false,
            fraudsCommentsOpen: false,

            openDialogConfirm: false,

            fraudId: null
        };
    }

    customLogicOnMount = async () => {
        const documentsRes = await this.fetchFraudsDocuments();
        const commentsRes = await this.fetchFraudsComments();
        this.fraudsDocuments = documentsRes.data;
        this.fraudsComments = commentsRes.data;
    };

    fetchFraudsDocuments = async () => {
        return await this.props.context
            .getState()
            .server.publicFraudDocuments.getAll();
    };
    fetchFraudsComments = async () => {
        return await this.props.context
            .getState()
            .server.publicFraudComments.getAll();
    };

    openFraudsDocuments = () => {
        const fraudId = this.state.menuClickItemId;
        const currentFraudDocuments = this?.fraudsDocuments.filter(
            (document) => document.fraud?.id === fraudId
        );
        this.setState({
            fraudsDocumentsOpen: true,
            currentFraudDocuments,
            fraudId
        });
        this.handleCloseMenu();
    };

    openFraudsComments = () => {
        const fraudId = this.state.menuClickItemId;
        const currentFraudComments = this.fraudsComments?.filter(
            (comment) => comment.fraud?.id === fraudId
        );
        this.setState({
            fraudsCommentsOpen: true,
            currentFraudComments,
            fraudId
        });
        this.handleCloseMenu();
    };

    closeFraudsDocuments = async () => {
        this.setState({ fraudsDocumentsOpen: false, fraudId: null });
    };

    closeFraudsComments = async () => {
        this.setState({ fraudsCommentsOpen: false, fraudId: null });
    };

    setFraudDocuments = async () => {
        const id = this.state.fraudId;
        const res = await this.fetchFraudsDocuments();
        this.fraudsDocuments = res.data;
        const currentFraudDocuments = res.data.filter(
            (document) => document.fraud?.id === id
        );
        this.setState({
            currentFraudDocuments
        });
    };

    setFraudComments = async () => {
        const id = this.state.fraudId;
        const res = await this.fetchFraudsComments();
        this.fraudsComments = res.data;
        const currentFraudComments = res.data.filter(
            (comment) => comment.fraud?.id === id
        );
        this.setState({ currentFraudComments });
    };

    renderCustomMenuItems() {
        const fraudId = this.state.menuClickItemId;
        const currentFraudCommentsLength =
            this.fraudsComments?.filter(
                (comment) => comment.fraud?.id === fraudId
            ).length || 0;
        const currentFraudDocumentsLength =
            this.fraudsDocuments?.filter(
                (document) => document.fraud?.id === fraudId
            ).length || 0;

        const value = this.List.find((item) => item.id === fraudId)?.state;

        const isAllowedChangeStatusAction =
            this.allowedAction('fraud-approve-reject') &&
            value &&
            value !== fraudStatuses.accepted &&
            value !== fraudStatuses.rejected;

        return [
            isAllowedChangeStatusAction && (
                <MenuItem
                    key="check"
                    onClick={() =>
                        this.handleUpdateStatusConfirm(fraudStatuses.accepted)
                    }
                >
                    <Iconify icon={'ic:baseline-check'} sx={{ mr: 2 }} />
                    {i18n.t('buttons.approve')}
                </MenuItem>
            ),
            isAllowedChangeStatusAction && (
                <MenuItem
                    key="reject"
                    onClick={() =>
                        this.handleUpdateStatusConfirm(fraudStatuses.rejected)
                    }
                >
                    <Iconify icon={'eva:close-fill'} sx={{ mr: 2 }} />
                    {i18n.t('buttons.reject')}
                </MenuItem>
            ),
            <MenuItem
                key="fraudDocuments"
                onClick={() => this.openFraudsDocuments()}
            >
                <TextSnippetIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.fraudsDocuments')}
                <Chip sx={{ ml: 1 }} label={currentFraudDocumentsLength} />
            </MenuItem>,
            <MenuItem
                key="fraudComments"
                onClick={() => this.openFraudsComments()}
            >
                <CommentIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.fraudsComments')}
                <Chip sx={{ ml: 1 }} label={currentFraudCommentsLength} />
            </MenuItem>
        ];
    }

    handleUpdateStatus = async () => {
        const { status } = this.state;
        const id = this.state.fraudId;

        await this.Server.updateStatus(id, status);
        this.setState({ openDialogConfirm: false, status: '', fraudId: null });
        await this.retrieveData();
    };
    handleCancelStatusConfirm = () => {
        this.setState({ openDialogConfirm: false, status: '', fraudId: null });
    };
    handleUpdateStatusConfirm = (status) => {
        const alertText = i18n.t(`common.${status}AlertText`);
        const alertTitle = i18n.t(`common.${status}AlertTitle`);
        const fraudId = this.state.menuClickItemId;
        this.setState({
            openDialogConfirm: true,
            status,
            alertText,
            alertTitle,
            fraudId
        });
        this.handleCloseMenu();
    };
    renderCustom() {
        const fraudId = this.state.fraudId;
        return (
            <div>
                <DocumentsDialog
                    dialogOpen={this.state.fraudsDocumentsOpen}
                    dialogData={this.state.currentFraudDocuments}
                    id={fraudId}
                    type="fraud"
                    onCancel={() => this.closeFraudsDocuments()}
                    fetchData={() => this.setFraudDocuments()}
                    context={this.props.context}
                />
                <CommentsDialog
                    dialogOpen={this.state.fraudsCommentsOpen}
                    dialogData={this.state.currentFraudComments}
                    id={fraudId}
                    type="fraud"
                    controller="publicFraudComments"
                    onCancel={() => this.closeFraudsComments()}
                    fetchData={() => this.setFraudComments()}
                />
                <ConfirmDialog
                    dialogOpen={this.state.openDialogConfirm}
                    alertText={this.state.alertText}
                    alertTitle={this.state.alertTitle}
                    onCancel={this.handleCancelStatusConfirm}
                    onConfirm={this.handleUpdateStatus}
                />
            </div>
        );
    }

    renderCustomGridCell(Component, row, field) {
        const dates = {
            fraudsDocuments: this.fraudsDocuments,
            fraudsComments: this.fraudsComments
        };
        const data = dates[field.id] || [];

        const currentData = data.filter((item) => item.fraud?.id === row.id);
        const value = currentData ? currentData.length : 0;

        return (
            <Component
                key={field.label}
                id={row.id}
                value={value}
                field={field}
                row={row}
                handleChange={this.handleChangeCell}
            />
        );
    }
}
